export let dataProps = {
    id: 0,
    cluster_name: ''
}


// WEBPACK FOOTER //
// ./src/store/modules/handloomCluster/properties.js